import { useAuthenticated } from "./useAuthenticated";

/**
 * Whether the current user has provisioner privileges (AgenticProvisioner role).
 * DEV mode bypasses the role check so local development matches sidebar behaviour.
 */
export function useIsProvisioner(): boolean {
  const auth = useAuthenticated();
  return (
    auth.state === "authenticated" &&
    (import.meta.env.DEV || auth.roles.includes("AgenticProvisioner"))
  );
}
